/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Doctor from './doctor';
import DoctorDetail from './doctor-detail';
import DoctorUpdate from './doctor-update';
import DoctorDeleteDialog from './doctor-delete-dialog';

const DoctorRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Doctor />} />
    <Route path="new" element={<DoctorUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorDetail />} />
      <Route path="edit" element={<DoctorUpdate />} />
      <Route path="delete" element={<DoctorDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorRoutes;
